<template>
  <div v-if="themesByCategoryLoading" class="d-flex flex-wrap relative ">
    <BaseSelectorLoading
      v-for="n in 6"
      :key="n"
      class="mr-2 mt-4"
    ></BaseSelectorLoading>
  </div>
  <div v-else class="d-flex flex-wrap relative">
    <!-- Activities Theme -->
    <BaseSelector
      class="pr-2 mt-4"
      :name="activitiesThemes.nameFr"
      :multiple="true"
      :options="activitiesThemes.themes"
      :value="search.activities"
      :oneValueRequired="false"
      :styleIsActiveIfValueEgalOptions="true"
      @updateValue="
        updateParameter(
          $event.map(x => x.nameEn),
          activitiesThemes.nameEn
        )
      "
      :attached="$route.name === 'home' ? true : false"
    ></BaseSelector>
    <!-- Travellers Theme -->
    <BaseSelector
      class="pr-2 mt-4"
      :name="travellersThemes.nameFr"
      :multiple="true"
      :options="travellersThemes.themes"
      :value="search.travellers"
      :oneValueRequired="false"
      :styleIsActiveIfValueEgalOptions="true"
      @updateValue="
        updateParameter(
          $event.map(x => x.nameEn),
          travellersThemes.nameEn
        )
      "
      :attached="$route.name === 'home' ? true : false"
    ></BaseSelector>
    <!-- Ambiances Theme -->
    <BaseSelector
      class="pr-2 mt-4"
      :name="ambiancesThemes.nameFr"
      :multiple="true"
      :options="ambiancesThemes.themes"
      :value="search.ambiances"
      :oneValueRequired="false"
      :styleIsActiveIfValueEgalOptions="true"
      @updateValue="
        updateParameter(
          $event.map(x => x.nameEn),
          ambiancesThemes.nameEn
        )
      "
      :attached="$route.name === 'home' ? true : false"
    ></BaseSelector>
    <!-- Transports Theme -->

    <BaseSelector
      v-show="seeAllFilters"
      class="pr-2 mt-4"
      :name="transportsThemes.nameFr"
      :multiple="true"
      :options="transportsThemes.themes"
      :value="search.transports"
      :oneValueRequired="false"
      :styleIsActiveIfValueEgalOptions="true"
      @updateValue="
        updateParameter(
          $event.map(x => x.nameEn),
          transportsThemes.nameEn
        )
      "
      :attached="$route.name === 'home' ? true : false"
    ></BaseSelector>

    <!-- Seasons Selector -->

    <BaseSelector
      v-show="seeAllFilters"
      class="pr-2 mt-4"
      :name="$t(`core.seasons.plural_SEASON`)"
      :multiple="true"
      :options="seasons.options"
      :value="seasons.value"
      :oneValueRequired="false"
      :styleIsActiveIfValueEgalOptions="true"
      @updateValue="
        updateParameter(
          $event.map(x => x.nameEn),
          'seasons'
        )
      "
      :attached="$route.name === 'home' ? true : false"
    ></BaseSelector>

    <!-- Media Selector -->

    <BaseSelector
      v-show="seeAllFilters"
      class="pr-2 mt-4"
      :name="$t(`core.media.name`)"
      :multiple="true"
      :options="media.options"
      :value="media.value"
      :oneValueRequired="false"
      :styleIsActiveIfValueEgalOptions="true"
      @updateValue="
        updateParameter(
          $event.map(x => x.nameEn),
          'media'
        )
      "
      :attached="$route.name === 'home' ? true : false"
    ></BaseSelector>

    <v-btn
      outlined
      rounded
      @click.stop="seeAllFilters = !seeAllFilters"
      class="mt-4 text-subtitle-1 grey-border-color white--background text-transform--none"
      v-text="
        seeAllFilters ? $t('app.seeLessFilters') : $t('app.seeMoreFilters')
      "
    ></v-btn>
  </div>
</template>

<script>
// COMPONENTS
import BaseSelectorLoading from "./../../core/components/BaseSelectorLoading";
// MIXINS
import ThemesByCategoryMixin from "../../core/mixins/ThemesByCategoryMixin";
// VARIABLE
import seasons from "./../../core/variables/seasons.json";
import media from "./../../core/variables/media.json";
export default {
  name: "SearchFilters",
  components: {
    BaseSelectorLoading
  },
  // MIXINS
  mixins: [ThemesByCategoryMixin],
  // DATAs
  props: {
    search: { type: Object, required: true }
  },
  data() {
    return {
      seeAllFilters: false
    };
  },
  computed: {
    seasons() {
      return {
        name: "seasons",
        options: seasons,
        value: this.search.seasons
      };
    },
    media() {
      return {
        name: "media",
        options: media,
        value: this.search.media
      };
    }
  },
  // METHODs
  methods: {
    updateParameter(value, parameter) {
      this.$emit("updateParameter", { value: value, parameter: parameter });
    }
  }
};
</script>

<style></style>
